import { initTranslations } from '../i18n';

export function initializeTranslation() {
  initTranslations([
    'messagebox',
    'global',
    'examinersTreemap',
    'examiners',
    'examinees',
    'context',
    'cards',
    'calendar',
    'assessments',
    'adminDashboard',
    'users',
    'systemSettings',
    'support',
    'sessionsParameters',
    'sessions',
    'sampleRepositorySchools',
    'sampleRepositoryRGZs',
    'sampleAssessment',
    'roles',
  ]);
}
